import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi
} from '@angular/common/http';
import {
  ErrorHandler,
  NgModule,
  Optional,
  PLATFORM_ID,
  SkipSelf
} from '@angular/core';
import { TokenInterceptor } from './interceptors/token.interceptor';
import {
  provideClientHydration,
  withEventReplay
} from '@angular/platform-browser';
import { CacheInterceptor } from './interceptors/cache.interceptor';
import { MsalModule } from '@azure/msal-angular';
import { MSAL_PROVIDERS } from './msal/msal.providers';
import { LOCAL_STORAGE } from './constants/context-token';
import { isPlatformServer } from '@angular/common';
import { StorageService } from './services/storage.service';
import { AuthService } from './services/auth.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { GlobalErrorHandler } from './errors/global-error-handler';
import { AdminGuard } from './guards/admin.guard';
import { CommonService } from './services/common.service';
import { LoaderService } from './services/loader.service';
import { TokenResolverService } from './services/token-resolver.service';

export const StorageProvider = {
  provide: LOCAL_STORAGE,
  useFactory: (platformId: object) => {
    if (isPlatformServer(platformId)) {
      return {};
    }
    return localStorage;
  },
  deps: [PLATFORM_ID]
};
const services = [
  StorageService,
  StorageProvider,
  AuthService,
  CommonService,
  LoaderService,
  TokenResolverService,
  AdminGuard
];

@NgModule({
  declarations: [],
  imports: [MsalModule],
  providers: [
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideClientHydration(withEventReplay()),
    provideAnimations(),
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    ...MSAL_PROVIDERS,
    ...services
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
